export function convertToTennisScore(points: number): string {
  if (points === 0) return '0'
  if (points === 1) return '15'
  if (points === 2) return '30'
  if (points === 3) return '40'
  return 'AD'
}

export function isDeuce(p1: number, p2: number): boolean {
  return p1 >= 3 && p2 >= 3 && p1 === p2
}

export function hasAdvantage(p1: number, p2: number): boolean {
  return p1 >= 3 && p2 >= 3 && Math.abs(p1 - p2) === 1
}

export function getDisplayScore(p: number, o: number): string {
  if (isDeuce(p, o)) return '40'
  if (hasAdvantage(p, o)) return p > o ? 'AD' : '40'
  return convertToTennisScore(p)
}

export function getDisplayScores(p1: number, p2: number): { score1: string; score2: string } {
  // At 3-3, display as "40" "40"
  if (p1 === 3 && p2 === 3) {
    return { score1: '40', score2: '40' }
  }
  
  // At 4-3, display as "Ad" "-"
  if (p1 === 4 && p2 === 3) {
    return { score1: 'Ad', score2: '-' }
  }
  if (p1 === 3 && p2 === 4) {
    return { score1: '-', score2: 'Ad' }
  }
  
  // At 4-4 or any equal score thereafter, display as "De" "De"
  if (p1 >= 4 && p2 >= 4 && p1 === p2) {
    return { score1: 'De', score2: 'De' }
  }
  
  // For advantage situations (one player leads by 1 after deuce)
  if (p1 >= 4 && p2 >= 4 && Math.abs(p1 - p2) === 1) {
    if (p1 > p2) {
      return { score1: 'Ad', score2: '-' }
    } else {
      return { score1: '-', score2: 'Ad' }
    }
  }
  
  // For normal scoring (0, 15, 30, 40)
  return {
    score1: convertToTennisScore(p1),
    score2: convertToTennisScore(p2)
  }
} 